import type { ReactNode } from 'react';

export interface GlobalNavGroupProps {
  navGroupKey: string;
  title: ReactNode;
  isExpandable?: boolean; // TODO: Delete this. It doesn't do anything.
  mobileHighlight?: ReactNode;
  children: ReactNode;
  isActive?: boolean;
  /** Fires when the user activates the group summary (same timing as DetailsSummary `summaryOnClick`). */
  onSummaryClick?: () => void;
}
